"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConductionMethod = void 0;
var ConductionMethod;
(function (ConductionMethod) {
    ConductionMethod["Default"] = "";
    ConductionMethod["OwnerAccount"] = "owner-account";
})(ConductionMethod = exports.ConductionMethod || (exports.ConductionMethod = {}));
//# sourceMappingURL=conduction-method.js.map